import { signal } from '@preact/signals';
import { User } from 'firebase/auth';

export const userSignal = signal<User | null | undefined>(undefined);
